import { useRouter } from 'next/router';
import { useCallback, useContext, useMemo } from 'react';

import { UserContext } from '~/components/providers/UserProvider';
import {
  getUseLocalStorageSettingsKey,
  useLocalStorageSettings,
} from '~/domains/common/hooks/useLocalStorageSettings';

export function useAnonymousContestCreation<T>() {
  const router = useRouter();
  const { user } = useContext(UserContext);

  const key = `contest::create`;
  const [value, setValue] = useLocalStorageSettings<T>(key, {} as T);

  const clearValue = useCallback(() => {
    try {
      localStorage.removeItem(getUseLocalStorageSettingsKey(key));
    } catch (error) {
      console.error(error);
      return value;
    }
  }, [key, value]);

  const hasValue = useMemo(() => !!Object.keys(value).length, [value]);
  const isAnonURL = router.query?.anon === 'true';

  return {
    isAnonymous: !user,
    isAnonURL,
    value,
    setValue,
    clearValue,
    hasValue,
  };
}
